( function( $ ) {
    "use strict";
    $(document).ready(function(){
        $('.feature-image, .animal-image').addClass('lazyload');

        var thumbs = $('div.gallery'),
            map;


        Window.nav = $('#site-navigation');

        thumbs.each(function() {
            var gallery = new Gallery(this);
            gallery.initLazy();
        });

        //$("#location-map").each(function() {
        //    var waypoint = new Waypoint({
        //        element: this,
        //        handler: function() {
        //            initMap();
        //            $(this).waypoint('destroy');
        //        },
        //        offset: 'top-in-view'
        //    });
        //});


        window.onscroll=fixHeader;


        $('.testimonial-slider').each(function() {
            $(this).owlCarousel({
                nav:true,
                dots:true,
                items:1,
                autoplay:true,
                autoplayTimeout:10000,
                autoplayHoverPause:true,
                autoHeight:true,
                loop:true
            });
        }).addClass('owl-carousel');

        //chrome on iOS won't render or trigger scroll events until
        //after the scroll action stops. For this browser only load
        //all the images when the page loads for better UX
        if (navigator.userAgent.match('CriOS')) {
            lazyLoadAll();
        }

    });

    
    function lazyLoadAll() {
        $('.lazyload').each(function() {
            lazySizes.loader.unveil($(this)[0]);
        });

    }


    $('.animal-title').flowtype({
        fontRatio : 11,
        maxFont: 30
    });

    $('.home-feature h1').flowtype({
        fontRatio : 12,
        maxFont: 40
    });

    //$('.home-feature p').flowtype({
    //    fontRatio : 50
    //});

    $('.section:not(.jumbotron) .section-title').flowtype({
        fontRatio : 100,
        minFont: 25
    });

    $('.entry-title').flowtype({
        fontRatio : 20,
        minFont: 35
    });


    //$('.testimonial blockquote').flowtype({
    //    fontRatio : 50,
    //});


    $('.page-template-default .entry-content h2').flowtype({
        fontRatio : 30,
        minFont: 30
    });

    function fixHeader(ev){
        if (window.pageYOffset>218) {
            Window.nav.addClass('fixed');
        } else {
            Window.nav.removeClass('fixed');
        };
    };


    function initMap() {
        if ($('#location-map').size()) {
            initLocationMap();
        }

        if ($('.sidebar-map').size()) {
            initSidebarMap($('.sidebar-map').first());
        }


    }

    window.initMap = initMap;

    function initLocationMap() {
        var customMapType = new google.maps.StyledMapType([{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.icon","stylers":[{"color":"#6e3a35"},{"saturation":"0"},{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#efebea"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#af9d94"},{"saturation":"0"},{"visibility":"off"}]},{"featureType":"landscape","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"hue":"#ff0000"},{"saturation":"34"},{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"},{"lightness":"60"},{"gamma":"1.00"},{"hue":"#ff0000"},{"saturation":"-90"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"saturation":"0"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"geometry.fill","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"geometry.stroke","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"on"},{"hue":"#ff0000"},{"saturation":"-90"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#dfd8d4"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]
            , {
                name: 'Custom Style'
            });

        var customMapTypeId = 'custom_style';

        var map = new google.maps.Map(document.getElementById('location-map'), {
            zoom: 12,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            draggable: false,
            streetViewControl: false,

            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId]
            }
        });


        var latlngbounds = new google.maps.LatLngBounds();

        var markers = [
            ["Glen Lyon Station", -44.15561,169.83215],
            ["Wanaka", -44.7031813, 169.1320981],
            ["Queenstown", -45.0311622, 168.6626435]
        ]

        $.each(markers, function(i, marker) {
            var loc = new google.maps.LatLng(marker[1], marker[2]);

            var marker = new google.maps.Marker({
                position: loc,
                map: map,
                title: marker[0]
            });

            latlngbounds.extend( loc );
        });

        map.mapTypes.set(customMapTypeId, customMapType);
        map.setMapTypeId(customMapTypeId);
        map.fitBounds(latlngbounds);

        google.maps.event.addDomListener(window, 'resize', function() {
            map.fitBounds(latlngbounds);
        });
    }

    function initSidebarMap($element) {
        var customMapType = new google.maps.StyledMapType([{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.icon","stylers":[{"color":"#6e3a35"},{"saturation":"0"},{"visibility":"on"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#efebea"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#af9d94"},{"saturation":"0"},{"visibility":"off"}]},{"featureType":"landscape","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"hue":"#ff0000"},{"saturation":"34"},{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"},{"lightness":"60"},{"gamma":"1.00"},{"hue":"#ff0000"},{"saturation":"-90"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"saturation":"0"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"},{"weight":"0.01"}]},{"featureType":"transit","elementType":"geometry.fill","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"geometry.stroke","stylers":[{"color":"#bfb1a9"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"on"},{"hue":"#ff0000"},{"saturation":"-90"},{"lightness":"0"},{"gamma":"1.00"},{"weight":"1"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#dfd8d4"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#6e3a35"},{"saturation":"0"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]
            , {
                name: 'Custom Style'
            });


        $element.height(450);

        var lat = $element.data('lat'),
            long = $element.data('long');



        var customMapTypeId = 'custom_style';

        var map = new google.maps.Map($element[0], {
            zoom: 7,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            draggable: false,
            streetViewControl: false,

            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId]
            }
        });



        var markers = [
            [name, lat, long]
        ]

        $.each(markers, function(i, marker) {
            var loc = new google.maps.LatLng(marker[1], marker[2]);

            var marker = new google.maps.Marker({
                position: loc,
                map: map,
                title: marker[0]
            });


            var latLng = marker.getPosition();
            map.setCenter(latLng);
        });

        map.mapTypes.set(customMapTypeId, customMapType);
        map.setMapTypeId(customMapTypeId);
    }


} )( jQuery );
